import { render } from "./SkuDifferenceModal.vue?vue&type=template&id=8f3e9852&ts=true&lang=pug"
import script from "./SkuDifferenceModal.vue?vue&type=script&lang=ts"
export * from "./SkuDifferenceModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__